module.exports = __webpack_public_path__ + "assets/img/共享.e2f7f3ab.png";